export enum ActivityCode {
  Low = 'low',
  Moderate = 'moderate',
  High = 'high',
}
